import { datadogLogs } from '@datadog/browser-logs'
import type { ClientLogger, ClientLoggerMethods, CreateLoggerParams } from './logger.types'
import { createLoggerMethods } from './logger.utils'

function createClientLogger({ name, defaultContext }: CreateLoggerParams): ClientLoggerMethods {
  const ddLogger = datadogLogs.createLogger(name)
  return {
    ...createLoggerMethods(ddLogger, defaultContext),
    setContextProperty: (key, value) => ddLogger.setContextProperty(key, value),
  }
}

export const logger: ClientLogger = {
  ...createLoggerMethods(datadogLogs.logger),
  setContextProperty: (key, value) => datadogLogs.logger.setContextProperty(key, value),
  createLogger: createClientLogger,
}
